<!-- =========================================================================================
    File Name: Maintenance.vue
    Description: Maintenance Page
    ----------------------------------------------------------------------------------------
    Item Name: BCC Pubs
      Author: SweetAs
    Author URL: http://sweetas.xyz
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img">
    <div class="h-screen flex w-full bg-img vx-row no-gutter justify-center items-center">
      <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
        <vx-card>
          <div slot="no-body" class="full-page-bg-color">
            <div class="vx-row no-gutter">
              <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                <img src="@/assets/images/pages/lock-screen.png" alt="login" class="mx-auto">
              </div>
              <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                <div class="p-8">
                  <div class="vx-card__title mb-8">
                    <h4 class="mb-4">Please Reset Your Password</h4>
                  </div>
                  <vs-input 
                    data-vv-validate-on="blur"
                    v-validate="'required|min:6|max:10'"
                    type="password"
                    icon-no-border
                    icon="icon icon-user" 
                    icon-pack="feather"
                    label-placeholder="Password" 
                    v-model="password" 
                    name="password"
                    class="w-full mb-6"/>

                   <vs-input 
                    data-vv-validate-on="blur"
                    v-validate="'required|min:6|max:10'"
                    type="password"
                    icon-no-border
                    icon="icon icon-user" 
                    icon-pack="feather"
                    label-placeholder="Password Verify" 
                    v-model="passwordverify" 
                    name="passwordverify"
                    class="w-full mb-6"/>

                  <vs-alert :active.sync="notvalid"  color="danger" class="text-center">
                     <span><b>Validation: Failed</b></span><br/>
                      <span>Password fields must match and be between 6-10 charactors long</span>
                  </vs-alert>
                  <vs-alert :active.sync="valid" color="success" class="text-center">
                    <span><b>Validation: Passed</b></span>
                  </vs-alert>
                  <div class="flex justify-between flex-wrap mt-5">
                      <router-link to="/login" class="mb-4">Home</router-link>
                      <vs-button :disabled="!validateForm" @click="resetPW">Update</vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router'
export default {
  props: ['id'],
  data () {
    return {
      password: '',
      passwordverify:'',
    }
  },
   computed: {
     notvalid(){
       return !this.validateForm && this.password.length>0
     },
     valid(){
       return this.validateForm && this.password.length>0
     },
    validateForm () {
      return !this.errors.any() && this.password !== '' && this.password === this.passwordverify
    },
  },
   methods: {
    resetPW () {

      // Loading
      this.$vs.loading()
      const payload = {        
        id: this.$route.params.id,   
        password: this.password,  
        verify: this.passwordverify        
      }     
      this.$store.dispatch('auth/resetPw', payload)
        .then(r => {
          this.$vs.loading.close()
          const t = JSON.parse(r.data.data).Status
          const col = t==="Success" ?"success":"danger"
          const msg = `Password change ${ t==="Success" ? "Successful" : " Failed"}`
          
            this.$vs.notify({
            title: 'Password Reset',
            text: msg,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color:col
          })          
          router.push('/login')              
        })
        .catch(error => {  
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  }
}
</script>
